module.exports = ".form-group {\r\n    margin: 0;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.acerta_w {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n}\r\n\r\n.row {\r\n    margin: 0;\r\n}\r\n\r\n/* .redimensiona {\r\n  margin-left: 210px;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/perfil/perfil.component.css
// module id = ./src/app/pages/perfil/perfil.component.css
// module chunks = main